{
  "error_share_native_abort": "Unable to share item – either there are no share targets, or you cancelled it.",
  "error_saving_color": "Cannot save new colour:",
  "close_entry": "Close",
  "error_share_native": "Unable to share item.",
  "share_copy_label": "Copy link to clipboard",
  "share_mail_label": "Share using e-mail",
  "share_wordpress_label": "Share on WordPress",
  "share_wallabag_label": "Save to Wallabag",
  "share_pocket_label": "Save to Pocket",
  "share_facebook_label": "Share on Facebook",
  "share_twitter_label": "Share on Twitter",
  "share_diaspora_label": "Share on Diaspora",
  "share_native_label": "Share",
  "info_url_copied": "URL copied to clipboard.",
  "error_configuration": "Unable to load configuration.",
  "article_actions": "Actions",
  "search_label": "Search term",
  "error_invalid_subsection": "Invalid subsection:",
  "error_offline_storage": "Offline storage error: {0}. Reloading may help. Disabling offline for now.",
  "error_sync": "Could not sync last changes from server:",
  "error_refreshing_source": "Cannot refresh sources:",
  "error_loading_stats": "Cannot load nav stats:",
  "error_loading": "Loading error:",
  "error_logout": "Could not log out:",
  "error_star_item": "Cannot star/unstar item:",
  "error_mark_item": "Cannot mark/unmark item:",
  "error_mark_items": "Cannot mark all visible items:",
  "error_unknown_source": "Unknown source ID:",
  "error_unknown_tag": "Unknown tag:",
  "error_load_tags": "Could not load tags:",
  "error_delete_source": "Could not delete source:",
  "error_add_source": "Could not add source:",
  "error_session_expired": "Session expired",
  "app_reload": "Reload",
  "app_update": "selfoss has been updated, please reload",
  "sources_refreshed": "Sources refreshed",
  "reload_list": "Reload list",
  "streamerror": "No items loaded, reload?",
  "error": "An error occurred",
  "no_title": "No title",
  "login_offline": "Offline storage",
  "login_invalid_credentials": "Wrong username/password",
  "login_password": "Password",
  "login_username": "Username",
  "login": "Log in",
  "more": "More",
  "no_entries": "No entries found",
  "source_refresh": "Refresh this source",
  "source_last_post": "Last post seen",
  "source_saved": "Saved",
  "source_cancel": "Cancel",
  "source_save": "Save",
  "source_type": "Type",
  "source_select": "Please select source",
  "source_comma": "Comma separated",
  "source_pwd_placeholder": "Not changed",
  "source_tags": "Tags",
  "source_autotitle_hint": "Leave empty to fetch title",
  "source_title": "Title",
  "source_new": "New unsaved source",
  "source_warn": "Really delete this source?",
  "source_delete": "Delete",
  "source_filter": "Filter",
  "source_edit": "Edit",
  "source_export": "Export sources",
  "source_opml": "or import an OPML file",
  "source_add": "Add source",
  "sources": "Sources",
  "loginbutton": "Log in",
  "logoutbutton": "Log out",
  "settingsbutton": "Settings",
  "refreshbutton": "Refresh sources",
  "searchremove": "Hide search",
  "searchbutton": "Search",
  "next": "Next",
  "open_window": "Open",
  "load_img": "Show images",
  "unmark": "Mark as unread",
  "mark": "Mark as read",
  "unstar": "Unstar",
  "star": "Star",
  "days": "{0,plural,zero {today},one {yesterday},other {# days ago}}",
  "seconds": "{0,plural,one {1 second},other {# seconds}} ago",
  "minutes": "{0,plural,one {1 minute},other {# minutes}} ago",
  "hours": "{0,plural,one {1 hour},other {# hours}} ago",
  "timestamp": "{0,date} {0,time}",
  "alltags": "All tags",
  "tags": "Tags",
  "offline_count": "Items available locally",
  "online_count": "Items available on the server",
  "starred": "Starred",
  "unread": "Unread",
  "newest": "Newest",
  "filter": "Filter",
  "markread": "Mark as read",
  "error_offline_storage_not_available": "Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.",
  "error_edit_source": "Could not save source changes:",
  "error_unwritable_logs": "Unable to write logs.",
  "error_check_system_logs": "An error occured, please check your system logs.",
  "error_check_log_file": "An error occured, please check the log file ‘{0}’.",
  "offline_navigation_unavailable": "Switching tags and sources is currently not available in offline mode.",
  "experimental": "Experimental",
  "entries_loading": "Loading entries…",
  "login_in_progress": "Trying to log in…",
  "login_error_generic": "Could not log in: {errorMessage}",
  "error_unauthorized": "Please {link_begin}sign in{link_end} to continue.",
  "no_sources": "No sources configured.",
  "source_menu": "More actions",
  "source_browse": "Browse",
  "source_params_loading": "Loading parameters…",
  "sources_loading": "Loading sources…",
  "source_deleting": "Deleting source…",
  "source_saving": "Saving source changes…",
  "source_go_to_settings": "Open in settings",
  "source_warn_cancel_dirty": "Discard unsaved changes?",
  "sources_leaving_unsaved_prompt": "Leave settings with unsaved source changes?",
  "tag_change_color_button_title": "Change colour",
  "article_reading_time": "{0} min read",
  "share_mastodon_label": "Share on Mastodon"
}
